import Vue from 'vue'
import Router from 'vue-router'

import LocationListView from './components/locations/LocationListView.vue'
import LocationEditView from './components/locations/LocationEditView.vue'
import FormEditView from './components/locations/FormEditView.vue'

import FormCreateView from './components/locations/FormCreateView.vue'
import LocationCreateView from './components/locations/LocationCreateView.vue'
import LoginView from './components/LoginView.vue'
import ProfileEditView from './components/ProfileEditView.vue'
import ResetPassword from './components/ResetPassword.vue'

import UserListView from './components/users/UserListView.vue'
import UserCreateView from './components/users/UserCreateView.vue'
import UserEditView from './components/users/UserEditView.vue'

import { store } from './store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    { path: '/users/reset-password/:token', component: ResetPassword, props: true, meta: { public: true } },
    { path: '/login/:token?', component: LoginView, props: true, meta: { public: true } },
    { path: '/locations', component: LocationListView, props: true },
    { path: '/locations/new-location', component: LocationCreateView, props: true },
    { path: '/locations/:id', component: LocationEditView, props: true },
    { path: '/locations/:id/new-form', component: FormCreateView, props: true },
    { path: '/forms/:id', component: FormEditView, props: true },
    { path: '/profile-page', component: ProfileEditView, props: true },
    { path: '/users', component: UserListView, props: true },
    { path: '/users/new-user', component: UserCreateView, props: true },
    { path: '/users/:id', component: UserEditView, props: true },

    { path: '*', redirect: '/locations' },
  ],
})

router.beforeEach(async(to, from, next) => {
  if (to.matched.every(route => route.meta.public)) {
    return next()
  }

  try {
    if (store.state.token) {
      if (!store.state.user) {
        await store.dispatch('loadUserSession')
      }
      next()
    } else {
      next('/login')
    }
  } catch (err) {
    console.log(to)
    alert('Cannot restore session, please login again.')
    console.error(err)
    next('/login')
  }
})

export default router
